import React from 'react';
import PropTypes from 'prop-types';

const ConfirmedFilter = props =>
  <div>
    <h2>Below is a List of all your Invitees</h2>
    <label>
      <input
        type="checkbox"
        onChange={props.toggleFilter}
        checked={props.isFiltered}
      />
      {" "}
      &larr; Click Here to Hide Unconfirmed Guests
    </label>
  </div>

ConfirmedFilter.propTypes ={
  toggleFilter: PropTypes.func.isRequired,
  isFiltered: PropTypes.bool.isRequired,
}

export default ConfirmedFilter;



// WEBPACK FOOTER //
// ./src/MainContent/ConfirmedFilter.js